import { render, staticRenderFns } from "./OfferGroupModal.vue?vue&type=template&id=58dde11f&scoped=true"
import script from "./OfferGroupModal.vue?vue&type=script&lang=js"
export * from "./OfferGroupModal.vue?vue&type=script&lang=js"
import style0 from "./OfferGroupModal.vue?vue&type=style&index=0&id=58dde11f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dde11f",
  null
  
)

export default component.exports